var exports = {};
var e = {
  fullscreenEnabled: 0,
  fullscreenElement: 1,
  requestFullscreen: 2,
  exitFullscreen: 3,
  fullscreenchange: 4,
  fullscreenerror: 5,
  fullscreen: 6
},
    n = ["webkitFullscreenEnabled", "webkitFullscreenElement", "webkitRequestFullscreen", "webkitExitFullscreen", "webkitfullscreenchange", "webkitfullscreenerror", "-webkit-full-screen"],
    l = ["mozFullScreenEnabled", "mozFullScreenElement", "mozRequestFullScreen", "mozCancelFullScreen", "mozfullscreenchange", "mozfullscreenerror", "-moz-full-screen"],
    r = ["msFullscreenEnabled", "msFullscreenElement", "msRequestFullscreen", "msExitFullscreen", "MSFullscreenChange", "MSFullscreenError", "-ms-fullscreen"],
    u = "undefined" != typeof window && void 0 !== window.document ? window.document : {},
    s = "fullscreenEnabled" in u && Object.keys(e) || n[0] in u && n || l[0] in u && l || r[0] in u && r || [],
    t = {
  requestFullscreen: function (n) {
    return n[s[e.requestFullscreen]]();
  },
  requestFullscreenFunction: function (n) {
    return n[s[e.requestFullscreen]];
  },

  get exitFullscreen() {
    return u[s[e.exitFullscreen]].bind(u);
  },

  get fullscreenPseudoClass() {
    return ":" + s[e.fullscreen];
  },

  addEventListener: function (n, l, r) {
    return u.addEventListener(s[e[n]], l, r);
  },
  removeEventListener: function (n, l, r) {
    return u.removeEventListener(s[e[n]], l, r);
  },

  get fullscreenEnabled() {
    return Boolean(u[s[e.fullscreenEnabled]]);
  },

  set fullscreenEnabled(e) {},

  get fullscreenElement() {
    return u[s[e.fullscreenElement]];
  },

  set fullscreenElement(e) {},

  get onfullscreenchange() {
    return u[("on" + s[e.fullscreenchange]).toLowerCase()];
  },

  set onfullscreenchange(n) {
    return u[("on" + s[e.fullscreenchange]).toLowerCase()] = n;
  },

  get onfullscreenerror() {
    return u[("on" + s[e.fullscreenerror]).toLowerCase()];
  },

  set onfullscreenerror(n) {
    return u[("on" + s[e.fullscreenerror]).toLowerCase()] = n;
  }

};
exports = t; //# sourceMappingURL=fscreen.cjs.production.js.map

export default exports;